export default __webpack_public_path__ + "static/media/SSGeomiconsSquared.98530900.ttf";